
import { Component, Mixins } from 'vue-property-decorator';
import { VueClass } from 'vue-class-component/lib/declarations';
import { AxVuetify } from '@/mixins';

import * as V from 'vuetify/lib';

const Base = V.VDataTable as VueClass<unknown>;

@Component
export default class VDataTable extends Mixins(Base, AxVuetify) {
  created() {
    Object.defineProperty(this, 'classes', {
      get: () => {
        return {
          ...this.baseClasses
        };
      }
    });
  }

  get classes() {
    return [];
  }
}
